import './App.css';
import {useEffect, useState} from 'react';
import {auth, storage, db} from './firebase.js';

function Perfil(props){

    const [user, setUser] = useState();
    const [progress, setProgress] = useState(0);
    const [file, setFile] = useState(null);

    useEffect(() => {

    },[])
    
    function criarConta(e){
        e.preventDefault();
        let email = document.getElementById('email-cadastro').value;
        let username = document.getElementById('username-cadastro').value;
        let senha = document.getElementById('senha-cadastro').value;

        auth.createUserWithEmailAndPassword(email,senha)
        .then((authUser)=>{
            authUser.user.updateProfile({
                displayName:username
            })
            alert('Conta criada com sucesso.');
            let modal = document.querySelector('.modalCriarConta');

            modal.style.display ="none";
        }).catch((err)=>{
            alert(err.message);
        });

    }

    function entrar(e){
        e.preventDefault();
        let email = document.getElementById('email-login').value;
        let senha = document.getElementById('senha-login').value;

        auth.signInWithEmailAndPassword(email,senha)
        .then((auth)=>{
            props.setUser(auth.user.displayName);
            //alert('Logado com sucesso.');
            window.location.href ="/";
        }).catch((err)=>{
            alert(err.message);
        })
    }

    function abrirModalCriarConta(e){
        e.preventDefault();
        
        let modal = document.querySelector('.modalCriarConta');

        modal.style.display = "block";
    }

    function fecharModalCriar(){ 
        let modal = document.querySelector('.modalCriarConta');

        modal.style.display ="none";

    }

    function sair(e) {
        e.preventDefault();
        auth.signOut().then(function(val){
            props.setUser(null);
            window.location.href ="/";
        })
    }
    

    return (        
        <div className="perfil">
            
            <div className="center">
                    <div className="header__logo">
                        <a href="/"><img src="https://i.postimg.cc/brMDPTCK/logocnoot.png" /></a>
                    </div>   
                    <h2 className="h2edit1">Editar perfil:</h2> 
                {
                    (props.user)?
                    <div className="header__logInfo">
                        
                        <div className="back__home"> 
                        <h2 className="h2edit">Editar perfil:</h2> 
                        <a href="/" ><i class="fas fa-home"></i></a>
                        <a className="message-create" href="/message"><i class="fas fa-inbox"></i></a> 
                        <a className="sair-create" onClick={(e)=>sair(e)} href="#"><i class="fas fa-power-off"></i></a>
                        </div>
                        
                    </div>
                    :
                    <div className="header__loginForm">
                        <form onSubmit={(e)=>entrar(e)}>
                            <input id="email-login" type="text" placeholder="E-mail"/>
                            <input id="senha-login" type="password" placeholder="Senha"/>
                            <input type="submit" name="acao" value="Entrar"/>
                        </form>
                        <div className="btn__criarConta">
                            <a onClick={(e)=>abrirModalCriarConta(e)} href="#">Cadastre-se</a>
                        </div>
                    </div>
                }
            </div>
            <body className="bodyperfil">
        {
            <div class="container">
               <div class="text-center">
                    <form className="foto-user">
                    <img src="https://i.postimg.cc/8CLzFJpN/pngwing-com.png" class="rounded"/>

                    </form>
                </div>

            </div>
        }   
            </body>
        </div>
        
    );

}

    
export default Perfil;